export default __webpack_public_path__ + "static/media/bell.4b504bba.svg";